import React, { useState } from 'react'
import { Popover, QRCode, Spin } from 'antd';
import { useRootStore } from '@/contexts';
import { LangText } from '@/components'
import { JAPAN_MALL_URL, VIP_URL, SAGAWA_URL } from '@/constants'
import { apiAuthAuthorize } from '@/service/api/authAuthorize'
import { PlatformEnum } from '@/service/api/types'
import { useTranslation } from 'react-i18next'
interface QRCodePopoverProps {
  children: React.ReactElement;
  platform: PlatformEnum
  linUrl?: string
}
const QRCodePopover = (props: QRCodePopoverProps) => {
  const { children, platform, linUrl } = props;
  const { userStore } = useRootStore()
  const { user } = userStore
  const [open, setOpen] = useState(false)
  const [qrCodeValue, setQrCodeValue] = useState('')
  const [loading, setLoading] = useState(false)
  const { i18n, t } = useTranslation()

  const handleClick = async () => {
    let ticket = ''
    let link = ''
    let searchParams: Record<string, string> = {}
    setLoading(true)
    // const { data } = await apiAuthAuthorize({
    //   platform,
    // })
    // ticket = data.ticket || '';
    setLoading(false)
    searchParams = {
      // ticket: ticket || '',
      lang: i18n.language || 'zh_CN'
    }
    switch (platform) {
      case PlatformEnum.JAPANMALL: {
        const tempLink = new URL(linUrl || JAPAN_MALL_URL)
        Object.keys(searchParams).forEach(key => {
          tempLink.searchParams.append(key, searchParams[key])
        })
        window.open(tempLink.toString(), '_blank')
        return;
      }

      case PlatformEnum.VIP: {
        const tempLink = new URL(linUrl || VIP_URL)
        Object.keys(searchParams).forEach(key => {
          tempLink.searchParams.append(key, searchParams[key])
        })
        link = tempLink.toString()
        break
      }

      case PlatformEnum.SGW: {
        const tempLink = new URL(linUrl || SAGAWA_URL)
        Object.keys(searchParams).forEach(key => {
          tempLink.searchParams.append(key, searchParams[key])
        })
        link = tempLink.toString()
        break
      }
    }
    setQrCodeValue(link);
    setOpen(true);
  }
  return (
    <Spin spinning={loading}>
      <Popover content={<div className='flex flex-col items-center'>
        <LangText lngKey='9538ba59' className='text-[18px] text-black leading-[1.5] mb-1 font-bold'>{t('9538ba59')}</LangText>
        {user && <LangText lngKey='d6a3b329' className='text-[14px] text-[#FF4D4F] leading-[1.5] mb-2'>{t('d6a3b329')}</LangText>}
        <QRCode value={qrCodeValue} />
      </div>} trigger={"click"} open={open} onOpenChange={(open) => {
        !open && setOpen(open)
        // if(user) {
        //   !open && setOpen(open)
        // } else {
        //   if(open) {
        //     handleClick()
        //   } else {
        //     setOpen(false)
        //   }
        // }
      }}>
        {
          React.cloneElement(children, {
            onClick: handleClick
          })
        }
      </Popover>
    </Spin>
  )

}

export default QRCodePopover